import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {lastValueFrom, Observable} from 'rxjs';
import {ConfigService} from '../../services/config.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadUtilService {
  public showLoader: boolean;

  constructor(private http: HttpClient, public configService: ConfigService) {
  }


  public async downloadFilesViaObservable(url: string, fileName?: string, inputData?) {

    const res$ = inputData ? this.downloadFilesBasedOnInput(url,inputData) : this.downloadFiles(url);
    const blob = await lastValueFrom(res$);

    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = fileName ? fileName : 'document.xls';
    a.click();
    URL.revokeObjectURL(objectUrl);
    // this.showLoader = false;

    // this.downloadFiles(url)
    //     .subscribe(blob => {
    //         const a = document.createElement('a');
    //         const objectUrl = URL.createObjectURL(blob);
    //         a.href = objectUrl;
    //         a.download = fileName ? fileName : 'document.xls';
    //         a.click();
    //         URL.revokeObjectURL(objectUrl);
    //         this.showLoader = false;
    //     });
  }

  downloadFilesBasedOnInput(url: string,inputData) {
    return this.http.post(url, inputData, {
      responseType: 'blob'
    });
  }

  downloadFiles(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob'
    });
  }

  /**
   * Downloads an image from a URL using fetch API (bypassing Angular's HTTP interceptor)
   * @param imageUrl The URL of the image to download
   * @returns Promise<Blob> The downloaded image as a Blob
   */
  async downloadImage(imageUrl: string): Promise<Blob> {
    try {
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.blob();
    } catch (error) {
      console.error('Error downloading image:', error);
      throw error;
    }
  }

  /**
   * Downloads an image and triggers the browser's download mechanism
   * @param imageUrl The URL of the image to download
   * @param fileName Optional filename for the downloaded image
   */
  async downloadImageAsFile(imageUrl: string, fileName?: string): Promise<void> {
    try {
      const blob = await this.downloadImage(imageUrl);
      
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);
      
      // Create a link element
      const link = document.createElement('a');
      link.href = url;
      
      // Set the download attribute with the filename
      link.download = fileName || this.getFileNameFromUrl(imageUrl);
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the URL object
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  }

  /**
   * Extracts filename from URL
   * @param url The URL to extract filename from
   * @returns string The extracted filename
   */
  private getFileNameFromUrl(url: string): string {
    const urlParts = url.split('/');
    return urlParts[urlParts.length - 1] || 'downloaded-image';
  }

  getLoader(): Observable<boolean> {
    return;
  }


}
